import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isAdminAuthenticated } from "../../lib/adminAuth";

const AdminProtectedRoute = () => {
  const location = useLocation();

  if (!isAdminAuthenticated()) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default AdminProtectedRoute;
